import { default as Endpoint } from '../../api/Endpoint';
import * as Constants from '../constants';

export function requestAssetTypes() {
  return {
    type: Constants.REQUEST_ASSET_TYPES
  };
}
export function receiveAssetTypes(json, error) {
  return {
    type: Constants.RECEIVE_ASSET_TYPES,
    data: json,
    error
  };
}

export function requestAsset(uuid, context) {
  return () => {
    return {
      type: Constants.REQUEST_ASSET,
      uuid,
      load: { context }
    };
  };
}
export function receiveAsset(uuid, context) {
  return (json, error) => {
    return {
      type: Constants.RECEIVE_ASSET,
      data: json,
      uuid,
      load: { context },
      error
    };
  };
}

export function requestAssets(page, load) {
  return () => {
    return {
      type: Constants.REQUEST_ASSETS,
      page,
      load
    };
  };
}
export function receiveAssets(page, load) {
  return (json, error) => {
    return {
      type: Constants.RECEIVE_ASSETS,
      data: json,
      page,
      load,
      error
    };
  };
}
export function requestAssetAttributes() {
  return {
    type: Constants.REQUEST_ASSET_ATTRIBUTES
  };
}
export function receiveAssetAttributes(json, error) {
  return {
    type: Constants.RECEIVE_ASSET_ATTRIBUTES,
    data: json,
    error
  };
}
export function requestAssetAttributeValues(loadContext) {
  return () => ({
    type: Constants.REQUEST_ASSET_ATTRIBUTE_VALUES,
    loadContext
  });
}
export function receiveAssetAttributeValues(key, loadContext) {
  return (json, error) => ({
    type: Constants.RECEIVE_ASSET_ATTRIBUTE_VALUES,
    key,
    loadContext,
    data: json,
    error
  });
}
export function requestAssetSummary() {
  return {
    type: Constants.REQUEST_ASSET_SUMMARY
  };
}
export function receiveAssetSummary(json, error) {
  return {
    type: Constants.RECEIVE_ASSET_SUMMARY,
    data: json,
    error
  };
}
export function requestAssetDistribution(key, page, loadContext) {
  return () => ({
    type: Constants.REQUEST_ASSET_DISTRIBUTION,
    key,
    page,
    loadContext
  });
}
export function receiveAssetDistribution(key, page, loadContext) {
  return (json, error) => ({
    type: Constants.RECEIVE_ASSET_DISTRIBUTION,
    key,
    page,
    loadContext,
    data: json,
    error
  });
}

export function requestRandomAsset() {
  return {
    type: Constants.REQUEST_RANDOM_ASSET
  };
}

export function receiveRandomAsset(type) {
  return (json, error) => {
    return {
      type: Constants.RECEIVE_RANDOM_ASSET,
      data: json,
      assetType: type,
      error
    };
  };
}

export function requestSaveAsset(mode, context) {
  return () => {
    return {
      type: Constants.REQUEST_SAVE_ASSET,
      mode,
      context
    };
  };
}

export function receiveSaveAsset(mode, context) {
  return (json, error) => {
    return {
      type: Constants.RECEIVE_SAVE_ASSET,
      mode,
      context,
      data: json,
      error
    };
  };
}

export function requestSaveAssetClass(mode, uuid) {
  return () => {
    return {
      type: Constants.REQUEST_SAVE_ASSET_CLASS,
      mode,
      uuid
    };
  };
}

export function receiveSaveAssetClass(mode, assetClass) {
  return (json, error) => {
    return {
      type: Constants.RECEIVE_SAVE_ASSET_CLASS,
      mode,
      data: json,
      error,
      assetClass
    };
  };
}

export function clearAssetSaveContext(context = null) {
  return {
    type: Constants.CLEAR_ASSET_SAVE_CONTEXT,
    context
  };
}

export function updateDistributionFilter(selection) {
  return {
    type: Constants.UPDATE_ASSET_DISTRIBUTION_FILTER,
    selection
  };
}

export function updateAssetFilter(filter) {
  return {
    type: Constants.UPDATE_ASSET_FILTER,
    filter
  };
}

export function clearAssetSearchContext() {
  return {
    type: Constants.CLEAR_ASSET_SEARCH_CONTEXT
  };
}

/**
 * filter
 *  - archived
 *    + returns assets that are either archived or not (nil = false)
 *    + values: true, or false
 *  - assetClassId
 *    + uuid of the asset class to limit results to
 *  - type
 *    + asset class name to limit the results to
 *  - name
 *    + partial string of the asset name to search
 *  - selectable
 *    + true or false to limit results to only available assets with valid date range
 *
 *  - customFilters (array of additional filters)
 *    + type (required vs. custom)
 *    + property (name of filter, special behavior for start_date and end_date)
 *    + predicate (startDate/endDate for date range, otherwise string value or '(empty)')
 *
 * pageOptions
 *  - page
 *    + page number to retrieve starting at 1
 *  - size
 *    + number of results to return (MM defaults to 25)
 *  - sortColumn
 *    - property
 *      + name of column to sort by
 *    - sortDirection
 *      + "asc" or "desc"
 *
 * loadOptions
 *  - mode
 *    + reset
 *    + combine (default)
 *  - context
 *    + name of node to put results into
 *    + paging and loading state are also grouped under this node
 *    + if left empty, results will be put under the node "default"
 *
 * @param filter
 * @param pageOptions
 * @param loadOptions
 * @param options
 * @returns {*}
 */
export function searchAssets(
  filter = {},
  pageOptions = {},
  loadOptions = {},
  options = {}
) {
  const params = [];
  if (pageOptions.page) {
    params.push({ key: 'page', value: pageOptions.page });
  }
  if (pageOptions.size) {
    params.push({ key: 'size', value: pageOptions.size });
  }
  if (filter.assetClassId) {
    params.push({ key: 'asset_class_id', value: filter.assetClassId });
  }
  if (filter.name) {
    params.push({ key: 'query', value: filter.name });
  }
  if (Object.keys(filter).includes('archived')) {
    params.push({ key: 'archived', value: filter.archived });
  }
  if (filter.assetClass) {
    params.push({ key: 'type', value: filter.assetClass });
  }
  if (filter.selectable) {
    params.push({ key: 'selectable', value: filter.selectable });
  }
  if (filter.ignore_children) {
    params.push({ key: 'ignore_children', value: filter.ignore_children });
  }
  if (filter.has_weather) {
    params.push({ key: 'has_weather', value: filter.has_weather });
  }
  if (filter.customFilters?.length) {
    filter.customFilters.forEach(item => {
      if (item.property) {
        if (item.type === 'required') {
          if (item.property === 'start_date' || item.property === 'end_date') {
            params.push({
              key: `${item.property}_from`,
              value: item.predicate.startDate.toISOString()
            });
            params.push({
              key: `${item.property}_to`,
              value: item.predicate.endDate.toISOString()
            });
          } else {
            params.push({ key: item.property, value: item.predicate });
          }
        } else if (item.type === 'custom') {
          const customValue =
            item.predicate === '(empty)' ? '' : item.predicate;
          params.push({ key: item.property, value: customValue });
        }
      }
    });
  }

  const sort = filter.sortColumn?.property || 'updated_at';
  const order = filter.sortColumn?.sortDirection || 'desc';
  params.push({ key: 'sort', value: sort });
  params.push({ key: 'order', value: order });

  const queryString = params.length
    ? '?' +
      params
        .map(p => `${encodeURIComponent(p.key)}=${encodeURIComponent(p.value)}`)
        .join('&')
    : '';
  const path = `ecs/api/asset${queryString}`;
  return new Endpoint(
    path,
    requestAssets(pageOptions, loadOptions),
    receiveAssets(pageOptions, loadOptions)
  )
    .withOptions(options)
    .call();
}

export function getAsset(uuid, context, options = {}) {
  const path = `ecs/api/asset/${uuid}`;
  return new Endpoint(
    path,
    requestAsset(uuid, context),
    receiveAsset(uuid, context)
  )
    .withOptions(options)
    .call();
}

export function getAssetTypes(options = {}) {
  const path = 'ecs/api/class?fallback=true&archived=all';
  return new Endpoint(path, requestAssetTypes, receiveAssetTypes)
    .withOptions(options)
    .call();
}

export function getRandomAsset(type, options = {}) {
  const path = `ecs/api/asset/random?type=${encodeURIComponent(type)}`;
  return new Endpoint(path, requestRandomAsset, receiveRandomAsset(type))
    .withOptions(options)
    .call();
}

export function getAssetSummary(options = {}) {
  const path = 'ecs/api/asset_summary';
  return new Endpoint(path, requestAssetSummary, receiveAssetSummary)
    .withOptions(options)
    .call();
}

export function getAssetDistributionByKey(
  key,
  filter = {},
  pageOptions = {},
  loadOptions = {},
  options = {}
) {
  const params = [];
  if (options.type) {
    params.push({ key: 'type', value: encodeURIComponent(options.type) });
  }
  if (pageOptions.page) {
    params.push({ key: 'page', value: pageOptions.page });
  }
  if (pageOptions.size) {
    params.push({ key: 'size', value: pageOptions.size });
  }
  if (filter.name) {
    params.push({ key: 'query', value: filter.name });
  }
  const sort = filter.sortColumn?.property || 'active';
  const order = filter.sortColumn?.sortDirection || 'desc';

  params.push({ key: 'sort', value: sort });
  params.push({ key: 'order', value: order });
  const queryString = params.length
    ? '?' + params.map(p => `${p.key}=${p.value}`).join('&')
    : '';

  const path = `ecs/api/asset_attributes/${encodeURIComponent(
    key
  )}/distribution${queryString}`;
  return new Endpoint(
    path,
    requestAssetDistribution(key, pageOptions.page, options.loadContext),
    receiveAssetDistribution(
      `${key}${options.type || ''}`,
      pageOptions.page,
      loadOptions
    )
  )
    .withOptions(options)
    .call();
}

export function getAssetAttributes(options = {}) {
  const path = 'ecs/api/asset_attributes';
  return new Endpoint(path, requestAssetAttributes, receiveAssetAttributes)
    .withOptions(options)
    .call();
}

export function getAssetAttributeValues(key, options = {}) {
  const path = `ecs/api/asset_attributes/${encodeURIComponent(key)}`;
  return new Endpoint(
    path,
    requestAssetAttributeValues(options.loadContext),
    receiveAssetAttributeValues(key, options.loadContext)
  )
    .withOptions(options)
    .call();
}

export function createAsset(asset, options = {}) {
  const path = 'ecs/api/asset';
  return new Endpoint(
    path,
    requestSaveAsset('create', options.context),
    receiveSaveAsset('create', options.context)
  )
    .withMethod('POST')
    .withBody(JSON.stringify(asset))
    .withOptions(options)
    .call();
}

export function refreshAsset(uuid, options = {}) {
  const path = `ecs/api/asset/${uuid}`;
  return new Endpoint(
    path,
    requestSaveAsset('refresh', options.context),
    receiveSaveAsset('refresh', options.context)
  )
    .withOptions(options)
    .call();
}

export function editAsset(asset, options = {}) {
  const payload = { ...asset }; // copy the asset so the delete calls don't mutate the original object
  const uuid = payload.uuid;
  delete payload.key;
  delete payload.uuid;
  const path = `ecs/api/asset/${uuid}`;
  return new Endpoint(
    path,
    requestSaveAsset('edit', options.context),
    receiveSaveAsset('edit', options.context)
  )
    .withMethod('POST')
    .withBody(JSON.stringify(payload))
    .withOptions(options)
    .call();
}

function normalizeParentChild(sourceAssetClass) {
  const assetClass = { ...sourceAssetClass };
  if (assetClass.isChild) {
    if (assetClass.parentSelection?.length) {
      assetClass.parent_class_id = assetClass.parentSelection[0].value;
    }
  } else {
    assetClass.parent_class_id = null;
  }
  delete assetClass.parentSelection;
  delete assetClass.isChild;
  return assetClass;
}

export function createAssetClass(assetClass, options = {}) {
  const assetClassToSave = normalizeParentChild(assetClass);

  const path = 'ecs/api/class';
  return new Endpoint(
    path,
    requestSaveAssetClass('create'),
    receiveSaveAssetClass('create')
  )
    .withMethod('POST')
    .withBody(JSON.stringify(assetClassToSave))
    .withOptions(options)
    .call();
}

export function editAssetClass(assetClass, options = {}) {
  const assetClassToSave = normalizeParentChild(assetClass);
  delete assetClassToSave.uuid;
  delete assetClassToSave.name;
  const path = `ecs/api/class/${assetClass.uuid}`;
  return new Endpoint(
    path,
    requestSaveAssetClass('edit'),
    receiveSaveAssetClass('edit')
  )
    .withMethod('POST')
    .withBody(JSON.stringify(assetClassToSave))
    .withOptions(options)
    .call();
}

export function deleteAssetClass(assetClass, options = {}) {
  const path = `ecs/api/class/${assetClass.uuid}`;
  return new Endpoint(
    path,
    requestSaveAssetClass('delete'),
    receiveSaveAssetClass('delete', assetClass)
  )
    .withMethod('DELETE')
    .withBody(JSON.stringify(assetClass))
    .withOptions(options)
    .call();
}

export function archiveAsset(asset, context, options = {}) {
  const path = `ecs/api/asset/${asset.uuid}/archive`;
  return new Endpoint(
    path,
    requestSaveAsset('archive', context),
    receiveSaveAsset('archive', context)
  )
    .withMethod('POST')
    .withOptions(options)
    .call();
}

export function unarchiveAsset(asset, context, options = {}) {
  const path = `ecs/api/asset/${asset.uuid}/archive`;
  return new Endpoint(
    path,
    requestSaveAsset('unarchive', context),
    receiveSaveAsset('unarchive', context)
  )
    .withMethod('DELETE')
    .withOptions(options)
    .call();
}

export function archiveAssetClass(assetClass, options = {}) {
  const path = `ecs/api/class/${assetClass.uuid}/archive`;
  return new Endpoint(
    path,
    requestSaveAssetClass('archive', assetClass.uuid),
    receiveSaveAssetClass('archive', assetClass)
  )
    .withMethod('POST')
    .withOptions(options)
    .call();
}

export function unarchiveAssetClass(assetClass, options = {}) {
  const path = `ecs/api/class/${assetClass.uuid}/archive`;
  return new Endpoint(
    path,
    requestSaveAssetClass('unarchive'),
    receiveSaveAssetClass('unarchive')
  )
    .withMethod('DELETE')
    .withOptions(options)
    .call();
}
